import { Alert } from '@/_components';

export function BulkDeleteError({
  hasIssues,
  name,
  pluralName,
}: {
  hasIssues: number;
  name: string;
  pluralName?: string;
}) {
  if (hasIssues) {
    const text = hasIssues === 1 ? name : (pluralName ?? `${name}s`);

    return (
      <article className="mt-2 px-6">
        <div className="">
          <Alert type="error">Sorry, We couldn&lsquo;t delete all selected {text}</Alert>
        </div>
      </article>
    );
  }

  return null;
}
